// workaround es7 issues
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import apolloProvider from './vue-apollo';

Vue.config.productionTip = false;

// progressive web app
import '@/registerServiceWorker';

// initialise dependencies
import '@/packages/fontawesome';
import '@/packages/sticky-directive';
import '@/packages/touch-events';
import '@/packages/photoswipe';
import '@/packages/line-clamp';
import '@/packages/lazyload';
import '@/packages/validate';
import '@/packages/checkbox';
import '@/packages/slider';
import '@/packages/portal';

// initialise custom global components
import '@/components';

// initialise the state
// - fetch setup
import '@/init';

// configure auto fetch page content
import '@/router/middleware';

import '@/assets/sass/main.sass';

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app');
